import React, { useState } from 'react'
import CharWindow from '../components/CharWindow/CharWindow'
import ExtendedInfo from '../components/ExtendedInfo/ExtendedInfo'
import EquipementTabModal from '../components/EquipmentTabModal/EquipementTabModal'
import SkillTree from '../components/SkillTree/SkillTree'
import ItemDescription from '../components/ItemDescription/ItemDescription'
import BattleTab from '../components/BattleTab/BattleTab'
import { ComparisonSync } from '../contexts/comparison'

function Simulator() {
	const currentLanguage = 'en'
	const [activeWindow, setActiveWindow] = useState(1)
	const [lastSelectedItem, setLastSelectedItem] = useState(0)

	function handleClick(e) {
		setActiveWindow(Number(e.target.value))
	}

	return (
		<div className='mainBody'>
			<ComparisonSync />
			<div className='CharWinAndInfo'>
				<CharWindow currentLanguage={currentLanguage} />
				<ExtendedInfo />
			</div>
			<div className='buttons'>
				<button
					className={'tab-btn' + (activeWindow === 1 ? ' active-tab' : '')}
					onClick={handleClick}
					value={1}
				>
					Gears
				</button>
				<button
					className={'tab-btn' + (activeWindow === 2 ? ' active-tab' : '')}
					onClick={handleClick}
					value={2}
				>
					Skills
				</button>
			</div>
			<div className='MainBody'>
				<div className='EquipAndSkills'>
					<EquipementTabModal
						currentLanguage={currentLanguage}
						lastSelectedItem={lastSelectedItem}
						setLastSelectedItem={setLastSelectedItem}
						className={activeWindow === 1 ? 'active' : 'inactive'}
					/>
					<SkillTree
						className={activeWindow === 2 ? 'active' : 'inactive'}
					/>
				</div>
				<div className='descAndBattle'>
					<ItemDescription lastSelectedItem={lastSelectedItem} />
					<BattleTab />
				</div>
			</div>
		</div>
	)
}

export default Simulator
